/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  TreeSelect,
} from 'antd';
import { getCuentasContables } from 'api/catalogos';
import {
  deleteAcreedorCuentaContable,
  getAcreedorCuentaContable,
  getAcreedoresCuentasContables,
  patchAcreedorCuentaContable,
  postAcreedorCuentaContable,
} from 'api/configuraciones/acreedoresCuentasContables';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Table from 'components/Table';
import React, { useState, useEffect } from 'react';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { getModelPermission } from 'utils/permission';

export const acreedorCuentaContablePermission = {
  permissionModel: 'acreedorcuentacontable',
  catalogsModels: [],
  tabsModels: [],
};

const AcreedoresCuentasContables = ({
  acreedorId,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cuentasContables, setCuentasContables] = useState([]);
  const [data, setData] = useState([]);

  const getPermission = getModelPermission(
    acreedorCuentaContablePermission.permissionModel,
    acreedorCuentaContablePermission.catalogsModels,
    acreedorCuentaContablePermission.tabsModels,
  );

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceived(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        concepto: e?.cuenta_contable,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const newData = [];
      let elementosPadre = [];
      _data.forEach((item) => {
        const clone = { ...item };
        const title = `${clone.clave_visible || clone.clave} - ${clone.nombre}`;
        clone.title = title;
        clone.value = clone.id;
        clone.key = clone.id;

        newData[clone.id] = clone;

        if (clone.cuenta_padre) {
          const padre = newData[clone.cuenta_padre];
          if (padre) {
            padre.children = padre.children || [];
            padre.children = [...padre.children, clone];
          } else {
            elementosPadre = [...elementosPadre, clone];
          }
        } else {
          elementosPadre = [...elementosPadre, clone];
        }
      });
      return elementosPadre;
    }
    return [];
  };

  const cuentaContableBuscar = (cuentas, val) => {
    let encontrado = null;
    cuentas.map((e) => {
      if (e.id === val) {
        encontrado = e;
      }
      if (e.children) {
        const contenidoHijo = cuentaContableBuscar(e.children, val);
        if (contenidoHijo) {
          encontrado = contenidoHijo;
        }
      }
      return null;
    });
    return encontrado;
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getAcreedoresCuentasContables({ acreedor: acreedorId });
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _cuentasContables,
        _data,
      ] = await Promise.all([
        getCuentasContables(),
        getAcreedoresCuentasContables({ acreedor: acreedorId }),
      ]);
      const formattedCuentas = normalizeCuentasContables(_cuentasContables);
      if (mounted) {
        setCuentasContables(formattedCuentas);
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _acreedorCuentaContable = await getAcreedorCuentaContable(match.id);
    // eslint-disable-next-line max-len
    const _descripcion = cuentaContableBuscar(cuentasContables, _acreedorCuentaContable?.cuenta_contable)?.descripcion;
    setTimeout(() => {
      if (_acreedorCuentaContable) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue({
            ...formatReceived(_acreedorCuentaContable),
            descripcion: _descripcion,
          });
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onChangeCuentaContable = (val) => {
    const _descripcion = cuentaContableBuscar(cuentasContables, val)?.descripcion;
    form.setFieldsValue({ descripcion: _descripcion });
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchAcreedorCuentaContable(key, { ...values, acreedor: acreedorId }) : postAcreedorCuentaContable({ ...values, acreedor: acreedorId }));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteAcreedorCuentaContable(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 400,
      render: (val) => cuentaContableBuscar(cuentasContables, val)?.title,
    },
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 400,
      render: (val) => cuentaContableBuscar(cuentasContables, val)?.descripcion,
    },
    {
      titleText: 'Fecha de Inactivacion',
      dataIndex: 'fecha_de_inactivacion',
      key: 'fecha_de_inactivacion',
      width: 100,
      render: (val) => val?.format(),
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          permission={getPermission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Cuentas Contables`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          width="50%"
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="cuenta_contable"
                  label="Cuenta Contable"
                  rules={rules.required}
                >
                  <TreeSelect
                    showSearch
                    treeNodeFilterProp="title"
                    treeData={cuentasContables}
                    onChange={onChangeCuentaContable}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="descripcion"
                  label="Descripción"
                >
                  <Input.TextArea
                    autoSize={{ minRows: 3, maxRows: 3 }}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_de_inactivacion"
                  label="Fecha de Inactivación"
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="La Cuenta Contable"
        />
      </Spin>
    </Row>
  );
};

export default AcreedoresCuentasContables;
